import React, { FC } from 'react';

import { useEmployeeJobQuery } from 'Dictionary/query/dictionaryQuery';
import {
  FormikAutocompleteField,
  FormikAutocompleteFieldProps,
} from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';

export interface EmployeeJobSelectFieldProps
  extends Omit<FormikAutocompleteFieldProps, 'options' | 'label'> {
  name: string;
  disabled?: boolean;
  required?: boolean;
}

export const EmployeeJobSelectField: FC<EmployeeJobSelectFieldProps> = ({
  name,
  disabled = false,
  required = true,
  ...otherProps
}) => {
  const { data = [], isLoading, refetch } = useEmployeeJobQuery();

  return (
    <FormikAutocompleteField
      name={name}
      label="Employee job role"
      disabled={disabled}
      options={data}
      loading={isLoading}
      onOpen={() => refetch()}
      required={required}
      multiple
      {...otherProps}
    />
  );
};
